export default {
    Region: process.env.REACT_APP_REGION, // Stack region
    ApiUri: process.env.REACT_APP_API_URL,// AWS AppSync endpoint
    AuthMode: process.env.REACT_APP_AUTH_MODE, // Primary AWS AppSync authentication type
    ApiKey: process.env.REACT_APP_API_KEY, // AppSync API Key
    ClientDatabasePrefix: process.env.REACT_APP_CLIENT_DATABASE_PREFIX,
};
